module.exports = __webpack_public_path__ + "static/img/service_qrcode_1.c57320d1.jpg";